var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-up-arrow.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5998 4L3.39956 4C3.32666 4.00023 3.2552 4.02037 3.19288 4.05825C3.13056 4.09614 3.07973 4.15033 3.04587 4.215C3.012 4.27967 2.99639 4.35237 3.0007 4.42527C3.00502 4.49817 3.02909 4.56851 3.07035 4.62872L6.67045 9.83801C6.81965 10.054 7.17886 10.054 7.32847 9.83801L10.9286 4.62872C10.9702 4.56864 10.9947 4.49826 10.9992 4.42524C11.0038 4.35222 10.9883 4.27935 10.9544 4.21454C10.9205 4.14973 10.8695 4.09547 10.807 4.05765C10.7445 4.01982 10.6728 3.99989 10.5998 4Z",
    fill: "#EB4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsDownArrow);
export default __webpack_public_path__ + "static/media/bxs-down-arrow.6a8ae0677d90a49e9352a734940c2141.svg";
export { ForwardRef as ReactComponent };